import React from 'react';
import { Save, RefreshCw, Database } from 'lucide-react';
import { PageConfig } from '../index';

// Page configuration
export const settingsPageConfig: PageConfig = {
  title: 'Configuración',
  description: 'Ajustes y configuración del sistema',
  actions: [
    {
      label: 'Sincronizar',
      icon: RefreshCw,
      onClick: () => {
        console.log('Sincronizando...');
        alert('Sincronizando datos con el servidor...');
      },
      variant: 'secondary',
    },
    {
      label: 'Guardar Cambios',
      icon: Save,
      onClick: () => {
        console.log('Guardando configuración');
        alert('Configuración guardada correctamente');
      },
      variant: 'primary',
    },
  ],
};

// Page component
export const SettingsPage: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8">
      <div className="flex flex-col items-center justify-center h-64 text-slate-400">
        <Database size={48} className="mb-4" />
        <p className="text-lg font-medium">Configuración del Sistema</p>
        <p className="text-sm mt-2">Gestiona productos, clientes y preferencias</p>
      </div>
    </div>
  );
};
